import React, { useContext, useEffect, useState } from "react";
import queryString from "query-string";
import { emitCancellationModalAction, emitCancellationModalImpression, } from "@catchoftheday/analytics";
import { CustomerContext } from "@catchoftheday/customer";
import { ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY, ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY, } from "../../../consts";
import { CancellationModal } from "../../pure/CancellationModal";
export const CancellationModalContainer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { data: customer, loading } = useContext(CustomerContext);
    const { membership } = customer || {};
    const openModal = () => {
        emitCancellationModalImpression();
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };
    useEffect(() => {
        if (typeof window !== "undefined") {
            const queryParams = queryString.parse(window?.location?.search);
            if (queryParams?.[ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY] === "l" &&
                membership?.doubleSubscription) {
                openModal();
            }
            else if (queryParams?.[ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY] === "1") {
                openModal();
            }
        }
    }, [membership?.doubleSubscription]);
    return (<CancellationModal isOpen={isOpen} loading={loading} onClose={() => {
            emitCancellationModalAction("close");
            closeModal();
        }} onConfirm={() => {
            emitCancellationModalAction("confirm");
            closeModal();
        }}/>);
};
